import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiNewsFeedPinComponent } from './fi-news-feed-pin/fi-news-feed-pin.component';
import { FiNewsFeedPinService } from '@fi-shared/fi-news-feed-shared/fi-news-feed-pin.service';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiNewsFeedPinSettingsDialogComponent } from './fi-news-feed-pin-settings-dialog/fi-news-feed-pin-settings-dialog.component';
import { FiDatePickerModule } from '@fi-shared/fi-date-picker';
import { MatIconModule } from '@angular/material/icon';
import { FiNewsFeedVisibilityHelperComponent } from './fi-news-feed-visibility-helper/fi-news-feed-visibility-helper.component';
import { FiNewsFeedSharedService } from '@fi-shared/fi-news-feed-shared/fi-news-feed-shared.service';

@NgModule({
    imports: [CommonModule, MatButtonModule, MatMenuModule, FiAppTextSharedModule, FiDatePickerModule, MatIconModule],
    declarations: [FiNewsFeedPinComponent, FiNewsFeedPinSettingsDialogComponent, FiNewsFeedVisibilityHelperComponent],
    providers: [FiNewsFeedPinService, FiNewsFeedSharedService],
    exports: [FiNewsFeedPinComponent, FiNewsFeedVisibilityHelperComponent],
})
export class FiNewsFeedSharedModule {}
